<template>
  <v-container class="custom-container responsive-height">
    <v-row>
      <v-col cols="12">
        <v-card class="px-8 pt-10 kyc-accounts-card deposit-form" elevation="0"
          :color="$vuetify.theme.dark ? '#131c29' : '#E0EAF2'">
          <v-row class="mb-8">
            <v-col cols="12" sm="7">
              <h3>KYC Verification & Control Access</h3>
            </v-col>
            <v-col cols="12" sm="7">
              <v-switch v-model="switch1" inset color="#039de9" :ripple="false" :disabled="$canRoute('kyc-set-access') !== 1">
                <template v-slot:label>
                  <div>
                    <span>Identity Verification</span>
                    <div class="details">
                      User Need to Upload Passport or Driving License
                    </div>
                  </div>
                </template>
              </v-switch>
            </v-col>

            <v-col cols="12" sm="8" class="custom-border pb-5">
              <v-switch class="mt-0" v-model="switch2" inset color="#039de9" :ripple="false" :disabled="$canRoute('kyc-set-access') !== 1">
                <template v-slot:label>
                  <div>
                    <span>Residence Verification</span>
                    <div class="details">
                      receipt of utility services payment or page of the local
                      passport with residential address
                    </div>
                  </div>
                </template>
              </v-switch>
              <!-- Conditional div based on switch state -->
              <v-col cols="12" sm="12">
                <div v-if="switch2" class="deposit-form">
                  <v-row dense>
                    <v-col cols="12" sm="12" class="mb-5">
                      <h3>
                        Select Functions or Pages to Lock For Who Are Not
                        Verified.
                      </h3>
                    </v-col>
                    <v-col cols="12" sm="12" class="mb-5">
                      <v-badge bordered color="#131c29" icon="mdi-lock" :left="true" overlap offset-x="30"
                        class="mr-3 mb-3 active-btn">
                        <v-btn outlined large rounded color="#FF567F">
                          Withdraw Page
                        </v-btn>
                      </v-badge>
                      <v-badge bordered color="#131c29" icon="mdi-lock" :left="true" overlap offset-x="30"
                        class="mr-3 mb-3">
                        <v-btn outlined large rounded color="#708AA7">
                          Add Bank Account
                        </v-btn>
                      </v-badge>
                      <v-badge bordered color="#131c29" icon="mdi-lock" :left="true" overlap offset-x="30"
                        class="mr-3 mb-3">
                        <v-btn outlined large rounded color="#708AA7">
                          Add Bank Account
                        </v-btn>
                      </v-badge>
                      <v-badge bordered color="#131c29" icon="mdi-lock" :left="true" overlap offset-x="30"
                        class="mr-3 mb-3">
                        <v-btn outlined large rounded color="#708AA7">
                          Deposit Page
                        </v-btn>
                      </v-badge>
                      <v-badge bordered color="#131c29" icon="mdi-lock" :left="true" overlap offset-x="30"
                        class="mr-3 mb-3 active-btn">
                        <v-btn outlined large rounded color="#FF567F">
                          Create Trading Account
                        </v-btn>
                      </v-badge>
                      <v-badge bordered color="#131c29" icon="mdi-lock" :left="true" overlap offset-x="30"
                        class="mr-3 mb-3">
                        <v-btn outlined large rounded color="#708AA7">
                          Deposit Page
                        </v-btn>
                      </v-badge>
                      <v-badge bordered color="#131c29" icon="mdi-lock" :left="true" overlap offset-x="30"
                        class="mr-3 mb-3">
                        <v-btn outlined large rounded color="#708AA7">
                          Deposit Page
                        </v-btn>
                      </v-badge>
                      <v-badge bordered color="#131c29" icon="mdi-lock" :left="true" overlap offset-x="30"
                        class="mr-3 mb-3">
                        <v-btn outlined large rounded color="#708AA7">
                          Deposit Page
                        </v-btn>
                      </v-badge>
                      <v-badge bordered color="#131c29" icon="mdi-lock" :left="true" overlap offset-x="30"
                        class="mr-3 mb-3 active-btn">
                        <v-btn outlined large rounded color="#FF567F">
                          Create Trading Account
                        </v-btn>
                      </v-badge>
                    </v-col>
                    <v-col cols="12" sm="12" class="mb-3">
                      <v-btn large tile block elevation="0" class="text-capitalize btn-account" color="greenMain"
                        :disabled="$canRoute('kyc-set-access') !== 1">
                        Save
                      </v-btn>
                    </v-col>
                  </v-row>
                </div>
                <div v-else class="d-none"></div>
              </v-col>
            </v-col>
          </v-row>
          <v-row class="mb-5 mt-0">
            <v-col cols="12" sm="8">
              <h3>Terms & Conditions Access Setting</h3>
            </v-col>
            <v-col cols="12" sm="8" class="custom-border pb-5">
              <v-switch class="mt-0 deposit-form" v-model="switch3" inset color="#039de9" :ripple="false"
                :disabled="$canRoute('kyc-set-access') !== 1">
                <template v-slot:label>
                  <div>
                    <span>Verify Terms & Conditions</span>
                    <div class="details">
                      receipt of utility services payment or page of the local
                      passport with residential address
                    </div>
                  </div>
                </template>
              </v-switch>
              <div v-if="switch3" class="mt-5">
                <v-row dense>
                  <v-col cols="12" sm="12" class="mb-5 mt-3">
                    <fieldset class="custom-upload-file">
                      <legend>Upload Terms & Condition PDF</legend>
                      <v-file-input label="Choose file (Max Size 2MB)" single-line solo prepend-icon="mdi-file-image"
                        hide-details class="custom-select" :disabled="$canRoute('kyc-set-access') !== 1"
                        @change="onFileChange"></v-file-input>
                      <v-img v-if="imageUrl" :src="imageUrl" height="40"></v-img>
                    </fieldset>
                  </v-col>
                </v-row>
                <v-row dense class="mt-5 deposit-form">
                  <v-col cols="12" sm="12" class="mb-5">
                    <h3>
                      Select Functions or Pages to Lock For Who Are Not
                      Verified.
                    </h3>
                  </v-col>

                  <v-col cols="12" sm="12" class="mb-5">
                    <v-badge bordered color="#131c29" icon="mdi-lock" :left="true" overlap offset-x="30"
                      class="mr-3 mb-3 active-btn">
                      <v-btn outlined large rounded color="#FF567F">
                        Withdraw Page
                      </v-btn>
                    </v-badge>
                    <v-badge bordered color="#131c29" icon="mdi-lock" :left="true" overlap offset-x="30"
                      class="mr-3 mb-3">
                      <v-btn outlined large rounded color="#708AA7">
                        Add Bank Account
                      </v-btn>
                    </v-badge>
                    <v-badge bordered color="#131c29" icon="mdi-lock" :left="true" overlap offset-x="30"
                      class="mr-3 mb-3">
                      <v-btn outlined large rounded color="#708AA7">
                        Add Bank Account
                      </v-btn>
                    </v-badge>
                    <v-badge bordered color="#131c29" icon="mdi-lock" :left="true" overlap offset-x="30"
                      class="mr-3 mb-3">
                      <v-btn outlined large rounded color="#708AA7">
                        Deposit Page
                      </v-btn>
                    </v-badge>
                    <v-badge bordered color="#131c29" icon="mdi-lock" :left="true" overlap offset-x="30"
                      class="mr-3 mb-3 active-btn">
                      <v-btn outlined large rounded color="#FF567F">
                        Create Trading Account
                      </v-btn>
                    </v-badge>
                    <v-badge bordered color="#131c29" icon="mdi-lock" :left="true" overlap offset-x="30"
                      class="mr-3 mb-3">
                      <v-btn outlined large rounded color="#708AA7">
                        Deposit Page
                      </v-btn>
                    </v-badge>
                    <v-badge bordered color="#131c29" icon="mdi-lock" :left="true" overlap offset-x="30"
                      class="mr-3 mb-3">
                      <v-btn outlined large rounded color="#708AA7">
                        Deposit Page
                      </v-btn>
                    </v-badge>
                    <v-badge bordered color="#131c29" icon="mdi-lock" :left="true" overlap offset-x="30"
                      class="mr-3 mb-3">
                      <v-btn outlined large rounded color="#708AA7">
                        Deposit Page
                      </v-btn>
                    </v-badge>
                    <v-badge bordered color="#131c29" icon="mdi-lock" :left="true" overlap offset-x="30"
                      class="mr-3 mb-3 active-btn">
                      <v-btn outlined large rounded color="#FF567F">
                        Create Trading Account
                      </v-btn>
                    </v-badge>
                  </v-col>
                  <v-col cols="12" sm="12" class="mb-3">
                    <v-btn large tile block elevation="0" class="text-capitalize btn-account" color="greenMain"
                      :disabled="$canRoute('kyc-set-access') !== 1">
                      Save
                    </v-btn>
                  </v-col>
                </v-row>
              </div>
              <div v-else class="d-none"></div>
            </v-col>
          </v-row>
          <v-row class="mb-5">
            <v-col cols="12" sm="8">
              <h3>Terms & Conditions Access Setting</h3>
            </v-col>
            <v-col cols="12" sm="8">
              <v-switch class="mt-0" v-model="switch4" inset color="#039de9" :ripple="false" :disabled="$canRoute('kyc-set-access') !== 1">
                <template v-slot:label>
                  <div>
                    <span>Question Answer Verification</span>
                    <div class="details">
                      receipt of utility services payment or page of the local
                      passport with residential address
                    </div>
                  </div>
                </template>
              </v-switch>
              <div v-if="switch4" class="deposit-form mt-5 pt-5">
                <v-row dense>
                  <v-col cols="12" sm="12" class="mb-5">
                    <h3>Write Your Question :</h3>
                  </v-col>
                  <v-col cols="12" sm="12" class="mb-3">
                    <fieldset class="custom-fieldset">
                      <legend>Question 1</legend>
                      <v-text-field label="Write Here" single-line solo hide-details
                        class="custom-select"></v-text-field>
                    </fieldset>
                  </v-col>
                  <v-col cols="12" sm="12" class="mb-3">
                    <fieldset class="custom-fieldset">
                      <legend>Question 2</legend>
                      <v-text-field label="Write Here" single-line solo hide-details
                        class="custom-select"></v-text-field>
                    </fieldset>
                  </v-col>
                  <v-col cols="12" sm="12" class="mb-3">
                    <fieldset class="custom-fieldset">
                      <legend>Question 3</legend>
                      <v-text-field label="Write Here" single-line solo hide-details
                        class="custom-select"></v-text-field>
                    </fieldset>
                  </v-col>
                  <v-col cols="12" sm="12" class="mb-3">
                    <fieldset class="custom-fieldset">
                      <legend>Question 4</legend>
                      <v-text-field label="Write Here" single-line solo hide-details
                        class="custom-select"></v-text-field>
                    </fieldset>
                  </v-col>
                  <v-col cols="12" sm="12" class="mb-3">
                    <fieldset class="custom-fieldset">
                      <legend>Question 5</legend>
                      <v-text-field label="Write Here" single-line solo hide-details
                        class="custom-select"></v-text-field>
                    </fieldset>
                  </v-col>
                </v-row>
                <v-row dense class="mt-5">
                  <v-col cols="12" sm="12" class="mb-5 mt-5 pt-5">
                    <h3>
                      Select Functions or Pages to Lock For Who Are Not
                      Verified.
                    </h3>
                  </v-col>
                  <v-col cols="12" sm="12" class="mb-5">
                    <v-badge bordered color="#131c29" icon="mdi-lock" :left="true" overlap offset-x="30"
                      class="mr-3 mb-3 active-btn">
                      <v-btn outlined large rounded color="#FF567F">
                        Withdraw Page
                      </v-btn>
                    </v-badge>
                    <v-badge bordered color="#131c29" icon="mdi-lock" :left="true" overlap offset-x="30"
                      class="mr-3 mb-3">
                      <v-btn outlined large rounded color="#708AA7">
                        Add Bank Account
                      </v-btn>
                    </v-badge>
                    <v-badge bordered color="#131c29" icon="mdi-lock" :left="true" overlap offset-x="30"
                      class="mr-3 mb-3">
                      <v-btn outlined large rounded color="#708AA7">
                        Add Bank Account
                      </v-btn>
                    </v-badge>
                    <v-badge bordered color="#131c29" icon="mdi-lock" :left="true" overlap offset-x="30"
                      class="mr-3 mb-3">
                      <v-btn outlined large rounded color="#708AA7">
                        Deposit Page
                      </v-btn>
                    </v-badge>
                    <v-badge bordered color="#131c29" icon="mdi-lock" :left="true" overlap offset-x="30"
                      class="mr-3 mb-3 active-btn">
                      <v-btn outlined large rounded color="#FF567F">
                        Create Trading Account
                      </v-btn>
                    </v-badge>
                    <v-badge bordered color="#131c29" icon="mdi-lock" :left="true" overlap offset-x="30"
                      class="mr-3 mb-3">
                      <v-btn outlined large rounded color="#708AA7">
                        Deposit Page
                      </v-btn>
                    </v-badge>
                    <v-badge bordered color="#131c29" icon="mdi-lock" :left="true" overlap offset-x="30"
                      class="mr-3 mb-3">
                      <v-btn outlined large rounded color="#708AA7">
                        Deposit Page
                      </v-btn>
                    </v-badge>
                    <v-badge bordered color="#131c29" icon="mdi-lock" :left="true" overlap offset-x="30"
                      class="mr-3 mb-3">
                      <v-btn outlined large rounded color="#708AA7">
                        Deposit Page
                      </v-btn>
                    </v-badge>
                    <v-badge bordered color="#131c29" icon="mdi-lock" :left="true" overlap offset-x="30"
                      class="mr-3 mb-3 active-btn">
                      <v-btn outlined large rounded color="#FF567F">
                        Create Trading Account
                      </v-btn>
                    </v-badge>
                  </v-col>
                  <v-col cols="12" sm="12" class="mb-3">
                    <v-btn large tile block elevation="0" class="text-capitalize btn-account" color="greenMain"
                      :disabled="$canRoute('kyc-set-access') !== 1">
                      Save
                    </v-btn>
                  </v-col>
                </v-row>
              </div>
              <div v-else class="d-none"></div>
            </v-col>
          </v-row>
        </v-card>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import { mapState } from "vuex";

export default {
  data() {
    return {
      imageUrl: null,
      switch1: false,
      switch2: true,
      switch3: true,
      switch4: true,
      dialog: false,
    };
  },
  computed: {
    ...mapState("admins", ["loggedAdmin"]),
  },
  methods: {
    onFileChange(file) {
      if (file) {
        this.imageUrl = URL.createObjectURL(file);
      } else {
        this.imageUrl = null;
      }
    },
  },
};
</script>
